export const COOKIE_MERCHANT_CODE = 'merchant_code';

export const fixedComponents = [
    '/store/dashboard',
    '/store/customers',
    '/pulse',
];

export default {
    COOKIE_MERCHANT_CODE,
    fixedComponents,
};
